import React from "react";
import useClipboard from "react-use-clipboard";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialog(props) {
  const baseURL = "https://herrealtors-app.web.app/embed/carousel";
  const [isCopied, setCopied] = useClipboard(
    `<iframe src="${baseURL}/${props.city}/${props.noOfCarousel}" title="Herrealtors ${props.city} Carousel" width="100%" height="100%" min-height="511px" frame-border="0" style="min-height:511px;"></iframe>`,
    {
      successDuration: 5000,
    }
  );

  const handleClose = () => {
    props.Close();
  };

  return (
    <div>
      <Dialog
        open={props.Open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Embed Link"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`<iframe src="${baseURL}/${props.city}/${props.noOfCarousel}" title="Herrealtors ${props.city} Carousel" width="100%" height="100%" min-height="511px" frame-border="0" style="min-height:511px;"></iframe>`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={setCopied} color="primary">
            {isCopied ? "Copied!" : "Copy"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
